import React from 'react';
import { Link } from 'react-router-dom';
import
    { Slider
    , FormGroup
    , Switch
    , Breadcrumbs
} from '@germix/germix-react-core';
import { withTranslation, WithTranslation } from 'react-i18next';

import Application from '../components/app/Application';
import hexToRgb from '../utils/hexToRgb';
import copyToClipboard from '../utils/copyToClipboard';

interface Props extends WithTranslation
{
}
interface State
{
    grayscale,
    sepia,
    blur,
    brightness,
    hueRotate,
    saturate,
    opacity,
    contrast,
    invert,
}

/**
 * @author Germán Martínez
 */
class RouteToolsFilter extends React.Component<Props,State>
{
    state: State =
    {
        grayscale: 0,
        sepia: 0,
        blur: 0,
        brightness: 100,
        hueRotate: 0,
        saturate: 100,
        opacity: 100,
        contrast: 100,
        invert: 0,
    }
    render()
    {
        const { t } = this.props;

        return (
<Application>
    <FormGroup>
        <Breadcrumbs>
            <Link to='/'>{t('titles.home')}</Link>
            <Link to='/tools'>{t('titles.tools')}</Link>
            <Link to='/tools/filter'>{t('titles.toolsFilterGenerator')}</Link>
        </Breadcrumbs>
        <br/>
    </FormGroup>
    <FormGroup>
        <h1>{t('titles.toolsFilterGenerator')}</h1>
    </FormGroup>
    <FormGroup>
        <div className="row">
            <div className="col">
                <FormGroup>
                    <div style={{display: 'flex'}}>
                        <label>{ t('toolFilter.grayscaleLabel')}</label>
                        <label className="ml-auto">{this.state.grayscale}%</label>
                    </div>
                    <Slider
                        min={0}
                        max={100}
                        value={this.state.grayscale}
                        onChange={(newValue) =>
                    {
                        this.setState({
                            grayscale: newValue,
                        });
                    }}/>
                </FormGroup>
                <FormGroup>
                    <div style={{display: 'flex'}}>
                        <label>{ t('toolFilter.sepiaLabel')}</label>
                        <label className="ml-auto">{this.state.sepia}%</label>
                    </div>
                    <Slider
                        min={0}
                        max={100}
                        value={this.state.sepia}
                        onChange={(newValue) =>
                    {
                        this.setState({
                            sepia: newValue,
                        });
                    }}/>
                </FormGroup>
                <FormGroup>
                    <div style={{display: 'flex'}}>
                        <label>{ t('toolFilter.blurLabel')}</label>
                        <label className="ml-auto">{this.state.blur}px</label>
                    </div>
                    <Slider
                        min={0}
                        max={20}
                        value={this.state.blur}
                        onChange={(newValue) =>
                    {
                        this.setState({
                            blur: newValue,
                        });
                    }}/>
                </FormGroup>
                <FormGroup>
                    <div style={{display: 'flex'}}>
                        <label>{ t('toolFilter.brightnessLabel')}</label>
                        <label className="ml-auto">{this.state.brightness}%</label>
                    </div>
                    <Slider
                        min={0}
                        max={200}
                        value={this.state.brightness}
                        onChange={(newValue) =>
                    {
                        this.setState({
                            brightness: newValue,
                        });
                    }}/>
                </FormGroup>
                <FormGroup>
                    <div style={{display: 'flex'}}>
                        <label>{ t('toolFilter.hueRotateLabel')}</label>
                        <label className="ml-auto">{this.state.hueRotate}°</label>
                    </div>
                    <Slider
                        min={0}
                        max={360}
                        value={this.state.hueRotate}
                        onChange={(newValue) =>
                    {
                        this.setState({
                            hueRotate: newValue,
                        });
                    }}/>
                </FormGroup>
                <FormGroup>
                    <div style={{display: 'flex'}}>
                        <label>{ t('toolFilter.saturateLabel')}</label>
                        <label className="ml-auto">{this.state.saturate}°</label>
                    </div>
                    <Slider
                        min={0}
                        max={1000}
                        value={this.state.saturate}
                        onChange={(newValue) =>
                    {
                        this.setState({
                            saturate: newValue,
                        });
                    }}/>
                </FormGroup>
                <FormGroup>
                    <div style={{display: 'flex'}}>
                        <label>{ t('toolFilter.opacityLabel')}</label>
                        <label className="ml-auto">{this.state.opacity}%</label>
                    </div>
                    <Slider
                        min={0}
                        max={100}
                        value={this.state.opacity}
                        onChange={(newValue) =>
                    {
                        this.setState({
                            opacity: newValue,
                        });
                    }}/>
                </FormGroup>
                <FormGroup>
                    <div style={{display: 'flex'}}>
                        <label>{ t('toolFilter.contrastLabel')}</label>
                        <label className="ml-auto">{this.state.contrast}%</label>
                    </div>
                    <Slider
                        min={0}
                        max={1000}
                        value={this.state.contrast}
                        onChange={(newValue) =>
                    {
                        this.setState({
                            contrast: newValue,
                        });
                    }}/>
                </FormGroup>
                <FormGroup>
                    <div style={{display: 'flex'}}>
                        <label>{ t('toolFilter.invertLabel')}</label>
                        <label className="ml-auto">{this.state.invert}%</label>
                    </div>
                    <Slider
                        min={0}
                        max={100}
                        value={this.state.invert}
                        onChange={(newValue) =>
                    {
                        this.setState({
                            invert: newValue,
                        });
                    }}/>
                </FormGroup>
            </div>
            <div className="col">
                <FormGroup>
                    <div style={{display: 'flex'}}>
                        <input className="form-control" value={this.fullFormatFilter()} readOnly={true} />
                        <span className="mini-button ml-1" onClick={() =>
                        {
                            copyToClipboard(this.fullFormatFilter());
                        }}>
                            <i className="icon-clipboard"></i>
                        </span>
                    </div>
                </FormGroup>
                <div className="simple-test-filter-panel">
                    <img src="/assets/image_for_filter.jpg"
                        style={{
                            filter: this.formatFilter()
                        }}
                    />
                </div>
            </div>
        </div>
    </FormGroup>
</Application>
        );
    }

    private formatFilter()
    {
        let params = [];
        if(this.state.grayscale > 0)
        {
            params.push('grayscale('+this.state.grayscale+'%)');
        }
        if(this.state.sepia > 0)
        {
            params.push('sepia('+this.state.sepia+'%)');
        }
        if(this.state.blur > 0)
        {
            params.push('blur('+this.state.blur+'px)');
        }
        if(this.state.brightness != 100)
        {
            params.push('brightness('+this.state.brightness+'%)');
        }
        if(this.state.hueRotate > 0)
        {
            params.push('hue-rotate('+this.state.hueRotate+'deg)');
        }
        if(this.state.saturate != 100)
        {
            params.push('saturate('+this.state.saturate+'%)');
        }
        if(this.state.opacity != 100)
        {
            params.push('opacity('+this.state.opacity+'%)');
        }
        if(this.state.contrast != 100)
        {
            params.push('contrast('+this.state.contrast+'%)');
        }
        if(this.state.invert > 0)
        {
            params.push('invert('+this.state.invert+'%)');
        }
        return params.join(' ');
    }

    private fullFormatFilter()
    {
        return 'filter: ' + this.formatFilter() + ';';
    }
}
export default withTranslation('common')(RouteToolsFilter);

